// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titulo-children h2 {
  color: var(--texto-destaque);
  font-size: 22px;
}

.h4-leaving {
  position: sticky;
  top: 0;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.h4-leaving-temporary {
  background-color: #e0f0ff;
  color: #2980b9;
}

.h4-leaving-definitive {
  background-color: #fdecea;
  color: #c0392b;
}

.leaving-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 15px;
  border-bottom: 1px solid var(--fundo, #f0f0f0);
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.leaving-item:hover {
  background-color: var(--fundo, #f5f5f5);
}

.leaving-top {
  width: 100%;
}

.leaving-bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-leaving-eye {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--azul);
  font-size: 15px;
  padding: 4px;
  flex-shrink: 0;
}

.btn-leaving-eye:hover {
  opacity: 0.7;
}

.leaving-name {
  flex: 1 1;
  font-weight: 600;
  color: var(--azul);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.leaving-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}

.leaving-label {
  font-size: 10px;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.leaving-date {
  font-size: 12px;
  color: #555;
}

.leaving-type {
  font-size: 12px;
  color: #555;
}

.leaving-empty {
  color: #888;
  font-size: 13px;
  padding: 15px;
}

.titulo-children2 .add-button {
  background-color: var(--fundo2);
  padding: 8px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--texto-destaque);
  font-weight: 600;
  opacity: .9;
}

:is(.titulo-children2 .add-button):hover {
    opacity: 1;
  }

.box-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 5px;
}

@media (max-width: 700px) {
  .box-container .box-home {
    flex-direction: column;
  }
}

.box-container .box-home {
  width: 100%;
  height: auto;
  min-height: 300px;
  max-height: 900px;
  display: flex;
  gap: 30px;
  border-radius: 12px;

}

@media (max-width: 700px) {

.box-container .box-home {
    width: 100%;
    height: 900px;

}
  }

:is(.box-container .box-home) .miniBox {
    position: relative;
    background-color: var(--branco);
    width: 100%;
    height: 100%;
    border-radius: 12px 12px 0 0;
    overflow-y: auto;
  }

:is(.box-container .box-home)  > h4 {
    margin-left: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--azul);
  }

:is(.box-container .box-home) .appointment h4 {
    position: sticky;
    top: 0;
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: var(--amarelo3);
    color: var(--amarelo2);
    display: flex;
    justify-content: space-between;
  }

:is(.box-container .box-home) .appointment .h4-atendimento-dia {
    background-color: lightblue;
    color: rgb(41, 159, 198);
  }

.container-title-home {
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  margin-bottom: 8px;
}

.container-title-home  > h3 {
    margin-left: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--azul);
  }

.container-title-home  > a {
    text-decoration: underline;
    color: var(--azul);
  }

.appointment-item {
  padding: 0 10px;
}

.internal-name {
  font-size: 15px;
  font-weight: 600;
  margin: 10px 0 6px;
  color: var(--azul);
}

.internal-schedulings {
  margin: 0;
  padding-left: 16px;
  list-style: disc;
  color: #444;
  font-size: 14px;
}

.internal-schedulings li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  padding: 6px 8px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.internal-schedulings li:hover {
  background-color: #f0f0f0;
}

.seta-acao {
  font-size: 15px;
  color: var(--texto-destaque);
}

.transfer-action-btn {
  font-size: 15px;
  color: var(--texto-destaque);
  text-decoration: underline;
  cursor: pointer;
}

/* Quantitativo */
.quantitative-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 20px;
  margin: 25px 0;
}

.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 18px 25px;
  border-radius: 10px;
  color: #fff;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
}

.card .icon {
  font-size: 30px;
  opacity: 0.3;
}

.card .info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.card .value {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 3px;
}

.card .label {
  font-size: 14px;
  opacity: 0.9;
}

.card .card-value-skeleton {
  width: 52px;
  height: 20px;
  margin-bottom: 3px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.55) 50%, rgba(255, 255, 255, 0.25) 75%);
  background-size: 200% 100%;
}

.card-dia {
  background: rgb(99, 179, 99);
}

.card-aberto {
  background: rgb(55, 96, 55);
}

.card-sentenciado {
  background: #5A9BD5;
}

.card-provisorio {
  background: #6495ED;
}

.card-fechado {
  background: #B22221;
}

.card-fugitivo {
  background: #842c2c;
}

.card-semiaberto {
  background: #FA8072;
}

.card-temporario {
  background: #87CEFA;
}

.card-civil {
  background: #2E86AB;
}

.card-vagas {
  background: lightgreen;
}

.table-home .home-schedule-item {
  font-size: 12px;
  line-height: 1.3;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/home.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AAKb;;AAHE;IACE,UAAU;EACZ;;AAGF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;;AA0CrB;;AAxCE;;AATF;IAUI,WAAW;IACX,aAAa;;AAsCjB;EArCE;;AAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;AAEA;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iCAAiC;IACjC,sBAAsB;IACtB,aAAa;IACb,8BAA8B;EAChC;;AAEA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;;AAIF;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AAcpB;;AAZE;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;AAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;AAGF;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,wCAAwC;EACxC,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,+HAA+H;EAC/H,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".titulo-children h2 {\n  color: var(--texto-destaque);\n  font-size: 22px;\n}\n\n.h4-leaving {\n  position: sticky;\n  top: 0;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.h4-leaving-temporary {\n  background-color: #e0f0ff;\n  color: #2980b9;\n}\n\n.h4-leaving-definitive {\n  background-color: #fdecea;\n  color: #c0392b;\n}\n\n.leaving-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 15px;\n  border-bottom: 1px solid var(--fundo, #f0f0f0);\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.leaving-item:hover {\n  background-color: var(--fundo, #f5f5f5);\n}\n\n.leaving-top {\n  width: 100%;\n}\n\n.leaving-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.btn-leaving-eye {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--azul);\n  font-size: 15px;\n  padding: 4px;\n  flex-shrink: 0;\n}\n\n.btn-leaving-eye:hover {\n  opacity: 0.7;\n}\n\n.leaving-name {\n  flex: 1;\n  font-weight: 600;\n  color: var(--azul);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.leaving-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.leaving-label {\n  font-size: 10px;\n  color: #aaa;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.leaving-date {\n  font-size: 12px;\n  color: #555;\n}\n\n.leaving-type {\n  font-size: 12px;\n  color: #555;\n}\n\n.leaving-empty {\n  color: #888;\n  font-size: 13px;\n  padding: 15px;\n}\n\n.titulo-children2 .add-button {\n  background-color: var(--fundo2);\n  padding: 8px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--texto-destaque);\n  font-weight: 600;\n  opacity: .9;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.box-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  padding: 5px;\n}\n\n@media (max-width: 700px) {\n  .box-container .box-home {\n    flex-direction: column;\n  }\n}\n\n.box-container .box-home {\n  width: 100%;\n  height: auto;\n  min-height: 300px;\n  max-height: 900px;\n  display: flex;\n  gap: 30px;\n  border-radius: 12px;\n\n  @media (max-width: 700px) {\n    width: 100%;\n    height: 900px;\n  }\n\n  .miniBox {\n    position: relative;\n    background-color: var(--branco);\n    width: 100%;\n    height: 100%;\n    border-radius: 12px 12px 0 0;\n    overflow-y: auto;\n  }\n\n  >h4 {\n    margin-left: 5px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--azul);\n  }\n\n  .appointment h4 {\n    position: sticky;\n    top: 0;\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background-color: var(--amarelo3);\n    color: var(--amarelo2);\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .appointment .h4-atendimento-dia {\n    background-color: lightblue;\n    color: rgb(41, 159, 198);\n  }\n\n}\n\n.container-title-home {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 32px;\n  margin-bottom: 8px;\n\n  >h3 {\n    margin-left: 5px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--azul);\n  }\n\n  >a {\n    text-decoration: underline;\n    color: var(--azul);\n  }\n}\n\n.appointment-item {\n  padding: 0 10px;\n}\n\n.internal-name {\n  font-size: 15px;\n  font-weight: 600;\n  margin: 10px 0 6px;\n  color: var(--azul);\n}\n\n.internal-schedulings {\n  margin: 0;\n  padding-left: 16px;\n  list-style: disc;\n  color: #444;\n  font-size: 14px;\n}\n\n.internal-schedulings li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  padding: 6px 8px;\n  border-radius: 6px;\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n}\n\n.internal-schedulings li:hover {\n  background-color: #f0f0f0;\n}\n\n.seta-acao {\n  font-size: 15px;\n  color: var(--texto-destaque);\n}\n\n.transfer-action-btn {\n  font-size: 15px;\n  color: var(--texto-destaque);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* Quantitativo */\n.quantitative-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 20px;\n  margin: 25px 0;\n}\n\n.card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  padding: 18px 25px;\n  border-radius: 10px;\n  color: #fff;\n  font-weight: bold;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n}\n\n.card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);\n}\n\n.card .icon {\n  font-size: 30px;\n  opacity: 0.3;\n}\n\n.card .info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.card .value {\n  font-size: 22px;\n  font-weight: bold;\n  margin-bottom: 3px;\n}\n\n.card .label {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.card .card-value-skeleton {\n  width: 52px;\n  height: 20px;\n  margin-bottom: 3px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.55) 50%, rgba(255, 255, 255, 0.25) 75%);\n  background-size: 200% 100%;\n}\n\n.card-dia {\n  background: rgb(99, 179, 99);\n}\n\n.card-aberto {\n  background: rgb(55, 96, 55);\n}\n\n.card-sentenciado {\n  background: #5A9BD5;\n}\n\n.card-provisorio {\n  background: #6495ED;\n}\n\n.card-fechado {\n  background: #B22221;\n}\n\n.card-fugitivo {\n  background: #842c2c;\n}\n\n.card-semiaberto {\n  background: #FA8072;\n}\n\n.card-temporario {\n  background: #87CEFA;\n}\n\n.card-civil {\n  background: #2E86AB;\n}\n\n.card-vagas {\n  background: lightgreen;\n}\n\n.table-home .home-schedule-item {\n  font-size: 12px;\n  line-height: 1.3;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
